// The Github README renderer turns links such ashttps://github.com/gevaertlab/AMARETTO/blob/master/inst/extdata/logo.jpg
// in to the raw image link. Extract these image URLs and change 'blob' to 'raw' to emulate the behavior of the Github UI.
export const rewriteGithubBlobImageURIs = (base) => {
  return function (tagName, attribs) {
    const val = attribs.src
    if (typeof val !== 'undefined') {
      // eslint-disable-next-line
      const githubBlobImages = new RegExp('(https{0,1}://github\.com/.*/.*)/blob/(.*\.(bmp|gif|jpg|jpeg|pdf|png|svg))', 'i')
      if (githubBlobImages.test(val)) {
        // replace blob with raw
        attribs.src = val.replace(githubBlobImages, '$1/raw/$2')
      }
    }
    return {
      tagName: tagName,
      attribs: attribs,
    }
  }
}

export const uriToAbs = (attr, base) => {
  return function (tagName, attribs) {
    let val = attribs[attr]
    if (typeof val !== 'undefined') {
      const schemeRE = /^(http|https|mailto):/
      if (schemeRE.test(val) || val.startsWith('//') || val.startsWith('#')) {
        // This is an absolute link or anchor; don't modify it
      } else {
        // Remove leading slashes
        val = val.replace(/^\/+/, '')
        val = base + val
        attribs[attr] = val
      }
    }
    return {
      tagName: tagName,
      attribs: attribs,
    }
  }
}
